import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00E676]/50 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-[#00E676] text-black shadow-[0_0_20px_rgba(0,230,118,0.3)] hover:bg-[#00FF88] hover:shadow-[0_0_25px_rgba(0,230,118,0.4)]",
        destructive:
          "bg-red-500/15 text-red-400 border border-red-500/30 shadow-sm hover:bg-red-500/25",
        outline:
          "border border-white/15 bg-transparent text-white shadow-sm hover:bg-white/10 hover:border-white/25",
        secondary:
          "bg-white/10 text-white shadow-sm hover:bg-white/20",
        ghost: "text-gray-300 hover:bg-white/10 hover:text-white",
        link: "text-[#00E676] underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-5 py-2",
        sm: "h-8 rounded-lg px-3 text-xs",
        lg: "h-12 rounded-lg px-8 text-base",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
